import React, { memo } from 'react';
import { useColorMode } from '../contexts/ColorModeContext';
import { useInspect } from '../contexts/InspectContext';
import { trackAppEvent } from '../services/analytics';
import { TbSourceCode } from 'react-icons/tb';
import { TbViewfinder } from "react-icons/tb";
import { useRuntimeConfigContext } from '../contexts/RuntimeConfigContext';

export default memo(({ data, children }) => {
  const runtimeConfig = useRuntimeConfigContext();
  const { sourceResolverBasePath, sourceWorkdirPath } = runtimeConfig.config;
  const isSourceResolverConfigurationSet = Boolean(sourceResolverBasePath && sourceWorkdirPath);
  const {
    accessModifier,
    returnType,
    arguments: methodArgs,
    classColor,
    methodId,
  } = data;
  const { colorMode } = useColorMode();
  const { inspectedMethodId, toggleInspect } = useInspect();

  // Create method signature display
  const argsString =
    methodArgs && methodArgs.length > 0
      ? methodArgs.map((arg) => `${arg.type} ${arg.name}`).join(', ')
      : 'no args';

  // Get the appropriate color based on access modifier
  const labelColor =
    accessModifier === 'public' ? classColor?.light : classColor?.dark;

  // Check if this method is being inspected
  const isInspected = inspectedMethodId === methodId;

  const handleInspectClick = () => {
    toggleInspect(methodId);

    // Track inspect action
    if (!isInspected) {
      trackAppEvent.graphInspect(data.label);
    }
  };

  return (
    <div>
      {/* Method name label positioned at top left corner */}
      <div
        style={{
          position: 'absolute',
          top: '-20px',
          left: '-8px',
          backgroundColor: labelColor,
          color: classColor?.contrastText,
          padding: '4px 8px',
          borderRadius: '4px',
          fontSize: '12px',
          fontWeight: 'bold',
          zIndex: 10,
          whiteSpace: 'nowrap',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        {data.label}
        <button
          onClick={handleInspectClick}
          style={{
            backgroundColor: isInspected ? '#ff4444' : 'transparent',
            color: 'white',
            border: isInspected ? '1px solid #ff6666' : '1px solid transparent',
            borderRadius: '3px',
            padding: '2px 6px',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            display: 'flex',
            flexDirection: 'row',
            gap: '4px',
            alignItems: 'center',
          }}
        >
          Inspect <TbViewfinder />
        </button>
        {isSourceResolverConfigurationSet && <a href={`${sourceResolverBasePath}${data.filePath}:${data.line}`}
          style={{
            backgroundColor: 'transparent',
            color: 'white',
            border: '1px solid transparent',
            borderRadius: '3px',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            whiteSpace: 'nowrap',
            display: 'flex',
            flexDirection: 'row',
            gap: '4px',
            alignItems: 'center',
          }}
        >
          Edit <TbSourceCode />
        </a>}
      </div>

      {/* Method signature details */}
      <div
        style={{
          position: 'absolute',
          top: '-35px',
          left: '0px',
          color: colorMode === 'dark' ? 'white' : 'black',
          padding: '2px 4px',
          borderRadius: '2px',
          fontSize: '8px',
          zIndex: 9,
          maxWidth: '180px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        ({argsString}) → {returnType || 'void'}
      </div>

      {/* Group content */}
      {children}
    </div>
  );
});
